import { useCallback, useEffect, useState } from "react";

/* Lee los proyectos del cliente desde la API del sistema de control de Aya (CGO),
   filtrando por su correo. La URL y la clave se definen en .env.local
   (VITE_CGO_API_URL / VITE_CGO_API_KEY). Expone `error` y `reload` para que la
   vista pueda distinguir "sin proyectos" de un fallo de conexión y reintentar. */
export function useClientProjects(email) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [attempt, setAttempt] = useState(0);

  const reload = useCallback(() => setAttempt((n) => n + 1), []);

  useEffect(() => {
    if (!email) {
      setItems([]);
      setError(null);
      setLoading(false);
      return;
    }
    let alive = true;
    setLoading(true);
    setError(null);
    (async () => {
      try {
        const apiUrl = import.meta.env.VITE_CGO_API_URL || "http://localhost:3000";
        const apiKey = import.meta.env.VITE_CGO_API_KEY || "cgo-aya-public-api-v1-9382";

        const res = await fetch(
          `${apiUrl}/api/public/client-projects?email=${encodeURIComponent(email)}`,
          { method: "GET", headers: { "x-api-key": apiKey } }
        );

        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const data = await res.json();
        if (!alive) return;
        setItems(Array.isArray(data) ? data : data?.items || []);
        setLoading(false);
      } catch (err) {
        if (!alive) return;
        setError(err);
        setItems([]);
        setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, [email, attempt]);

  return { items, loading, error, reload };
}
